import { render, staticRenderFns } from "./RecogForm.vue?vue&type=template&id=313198e4&scoped=true&"
import script from "./RecogForm.vue?vue&type=script&lang=ts&"
export * from "./RecogForm.vue?vue&type=script&lang=ts&"
import style0 from "./RecogForm.vue?vue&type=style&index=0&id=313198e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313198e4",
  null
  
)

export default component.exports